<template>
  <div class="content">
    <ToolTitle :title="form.name" :menu="true" :menuby="'form'" />
    <ToolLoading v-if="!isloaded" />
    <div v-if="isloaded" class="content__form">
      <FormInfo
        :title="'URL:'"
        :text="`${site}/${form.company.path}/${form.path}`"
        :copyicon="true"
        :link="true"
      />
      <FormInput :placeholder="'Form adı...'" :required="true" v-model.trim="form.name" />
      <FormInputTextarea :maxheight="500" :minheight="100" v-model="form.smtp.messagetoadmin" />
      <select v-model="form.period.unlimited">
        <option value="Süresiz">Süresiz</option>
        <option value="Süreli">Süreli</option>
      </select>
      <datetime
        v-if="form.period.unlimited != 'Süresiz'"
        type="datetime"
        v-model="form.period.enddate"
      ></datetime>
      <FormInfo :title="'Oluşturan:'" :text="`${form.created.by} - ${form.created.date}`" />
      <FormInfo
        v-if="form.updated.date"
        :title="'Son düzenleyen:'"
        :text="`${form.updated.by} - ${form.updated.date}`"
      />
      <FormCheckbox :placeholder="'Aktif/Pasif'" v-model="form.status" />
      <FormButton @action="update()" :text="'Kaydet'" :status="status" />
    </div>
  </div>
</template>

<script>
import * as API from "@/services/";
import { global } from "@/global";
import * as Helpers from "@/helpers/";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  components: {
    Datetime
  },
  data() {
    return {
      form: {},
      datetime: null,
      isloaded: false,
      site: `${global["API"]}/${global["FORMPATH"]}`,
      status: {
        loading: false,
        message: "",
        type: ""
      }
    };
  },
  watch: {
    "form.period.unlimited": function(val) {
      if (val == "Süreli" && !this.form.period.enddate) {
        this.form.period.enddate = new Date().toISOString();
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init: async function() {
      let vm = this;

      await API.getForm(vm.$route.params.company, vm.$route.params.form).then(
        response => {
          vm.form = response.result;
        }
      );

      vm.isloaded = true;
    },
    update: async function() {
      let vm = this;

      vm.status.loading = true;
      vm.status.type = "";
      vm.status.message = "Form düzenleniyor...";

      if (vm.form.period.unlimited === "Süresiz") vm.form.period.enddate = null;

      vm.form.updated = {
        by: vm.$store.getters.getUser,
        date: await Helpers.currentDateTime()
      };

      await API.updateForm(vm.form)
        .then(async response => {
          vm.status.type = "Success";
          if (response.status.code != 200) vm.status.type = "Error";
          vm.status.message = response.status.message;

          vm.$router.replace({
            name: "form",
            params: {
              form: response.result.path,
              company: response.result.company.path
            }
          });

          vm.form = response.result;
        })
        .catch(error => {
          vm.status.type = "Error";
          vm.status.message = error;
        });

      vm.status.loading = false;
    }
  }
};
</script>